export const WAIVER_VERSION = "2026.3";

// SHA-256 of public/waiver.pdf. Update this whenever the waiver changes.
export const WAIVER_HASH =
  "c18a67e3a73c00f0e364967ef3cbdf713bd9cab36c1ee70073de2c71935a8b7b";

const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

export const formatBirthDate = (value: string): string => {
  const match = DATE_PATTERN.exec(value);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : value;
};

export const parseBirthDate = (value: string): Date | null => {
  const match = DATE_PATTERN.exec(value);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
};

export const calculateAge = (birthDate: Date, currentDate = new Date()) => {
  let age = currentDate.getFullYear() - birthDate.getFullYear();
  const birthdayHasOccurred =
    currentDate.getMonth() > birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() &&
      currentDate.getDate() >= birthDate.getDate());

  if (!birthdayHasOccurred) age -= 1;
  return age;
};

export const isAdultOnDate = (
  birthDateValue: string,
  currentDate = new Date()
): boolean | null => {
  const birthDate = parseBirthDate(birthDateValue);
  if (!birthDate || birthDate > currentDate) return null;
  return calculateAge(birthDate, currentDate) >= 18;
};
